import API from "@/api/ExpertAPI";
import store from "@/store"

class ExpertController {
    constructor() {
        this.api = API
    }

    getUserId() {
        return store.getters["keycloak/getAuthData"]['sub']
    }

    async getApplicatioinArchive(orgId) {
        try {
            const res = await this.api.getApplicationArchive(orgId);
            return res.data
        } catch (e) {
            console.error('error getApplicatioinArchive ' + e.message);
            throw new Error('error getApplicatioinArchive ' + e.message)
        }
    }

    async setCommentToApplicatioin(orgId, comment) {
        try {
            const res = await this.api.setComment(orgId, comment);
            return res.data
        } catch (e) {
            console.error('error setCommentToApplicatioin ' + e.message);
            throw new Error('error setCommentToApplicatioin ' + e.message)
        }
    }

    async getProtocols() {
        try {
            const res = await this.api.getProtocols();
            res.data.forEach(protocol => {
                if (protocol.questions){
                    protocol.questions.forEach(question => {
                        question.protocolId = protocol.id
                        if (question.answers.length > 0) {
                            const tmp = question.answers.find(el => el.expertId === this.getUserId())
                            if (tmp) {
                                question.answer = tmp.answerNumber
                            }
                        } else {
                            question.answer = -1
                        }
                    })
                    protocol.questions.sort((a, b) => a.number - b.number)
                }
            })
            return res.data
        } catch (e) {
            console.error('error getProtocols ' + e.message);
            throw new Error('error getProtocols ' + e.message)
        }
    }

    async setAnswer(protocolId, questionId, answer, comment){
        try {
            const res = await this.api.setAnswer(protocolId, questionId, answer, comment);
            res.data.questions.forEach(question => {
                question.protocolId = res.data.id
                if (question.answers.length > 0) {
                    const tmp = question.answers.find(el => el.expertId === this.getUserId())
                    if (tmp) {
                        question.answer = tmp.answerNumber
                    }
                } else {
                    question.answer = -1
                }
            })
            res.data.questions.sort((a, b) => a.number - b.number)
            return res.data
        } catch (e) {
            console.error('error setAnswer ' + e.message);
            throw new Error('error setAnswer ' + e.message)
        }
    }
}

export default new ExpertController()